
import ErrorDialog from './ErrorDialog';
import ErrorPopover from './ErrorPopover';
import { useErrorStore } from '../../stores/errorStore';

export default function ErrorRenderer() {
  const { errors, removeError } = useErrorStore();

  // Separate dialog and popover errors
  const dialogErrors = errors.filter(error => error.type !== 'popover');
  const popoverErrors = errors.filter(error => error.type === 'popover');

  return (
    <>
      {/* Render Dialog Errors */}
      {dialogErrors.map((error) => (
        <ErrorDialog
          key={error.id}
          isOpen={true}
          onClose={() => removeError(error.id)}
          title={error.title}
          message={error.message}
          code={error.code}
        />
      ))}

      {/* Render Popover Errors - these are rendered inline where needed */}
      {popoverErrors.map((error) => (
        error.trigger && (
          <ErrorPopover
            key={error.id}
            trigger={error.trigger}
            title={error.title}
            message={error.message}
            code={error.code}
            position={error.position}
          />
        )
      ))}
    </>
  );
}